import React from 'react';
import { motion } from 'framer-motion';
import { GlassCard } from '../ui/GlassCard';
import { Eye, MousePointer2, ShieldCheck, Target } from 'lucide-react';
export function Slide04Layers() {
  const layers = [{
    num: '01',
    title: 'Attention Metrics',
    icon: Eye,
    metrics: ['CTR', 'Hook engagement', 'Bounce rate'],
    color: 'from-snakker-ink/5 to-transparent',
    accent: 'text-snakker-muted'
  }, {
    num: '02',
    title: 'Engagement Metrics',
    icon: MousePointer2,
    metrics: ['Interaction depth', 'Completion rate', 'Video exploration', 'Deep-dives'],
    color: 'from-snakker-primary/15 to-transparent',
    accent: 'text-snakker-primary'
  }, {
    num: '03',
    title: 'Understanding & Trust',
    icon: ShieldCheck,
    metrics: ['Quiz progression', 'Confidence shifts', 'Poll behavior', 'Reference opens'],
    color: 'from-snakker-secondary/15 to-transparent',
    accent: 'text-snakker-secondary'
  }, {
    num: '04',
    title: 'Intent & Action',
    icon: Target,
    metrics: ['CTA clicks', 'Website visits', 'Rep requests', 'Follow-up engagement'],
    color: 'from-snakker-primary/20 to-snakker-secondary/10',
    accent: 'text-snakker-ink'
  }];
  return <div className="w-full h-full flex flex-col max-w-7xl mx-auto pt-10" data-id="element-103">
      <motion.h2 className="text-[clamp(2.5rem,4vw,4rem)] font-light tracking-tight mb-16 text-snakker-ink" initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} data-id="element-104">
        The four layers of{' '}
        <span className="text-snakker-subtle" data-id="element-105">measurable engagement.</span>
      </motion.h2>

      <div className="grid grid-cols-2 gap-6 flex-1 mb-10" data-id="element-106">
        {layers.map((layer, i) => <motion.div key={layer.num} initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: i * 0.15 + 0.2
      }} data-id="element-107">
            <GlassCard className="h-full flex flex-col group hover:border-snakker-ink/20 transition-colors" hoverEffect data-id="element-108">
              <div className="flex justify-between items-start mb-8" data-id="element-109">
                <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${layer.color} flex items-center justify-center border border-snakker-border`} data-id="element-110">
                  <layer.icon className={`w-6 h-6 ${layer.accent}`} data-id="element-111" />
                </div>
                <span className="font-display text-4xl font-light text-snakker-ink/10 group-hover:text-snakker-ink/20 transition-colors" data-id="element-112">
                  {layer.num}
                </span>
              </div>

              <h3 className="text-2xl font-medium mb-6 text-snakker-ink" data-id="element-113">
                {layer.title}
              </h3>

              <ul className="space-y-3 mt-auto" data-id="element-114">
                {layer.metrics.map((metric, j) => <li key={j} className="flex items-center gap-3 text-snakker-muted" data-id="element-115">
                    <div className="w-1.5 h-1.5 rounded-full bg-snakker-ink/20" data-id="element-116" />
                    {metric}
                  </li>)}
              </ul>

              {/* Decorative sparkline simulation */}
              <div className="absolute bottom-6 right-6 w-24 h-8 opacity-30 group-hover:opacity-60 transition-opacity" data-id="element-117">
                <svg viewBox="0 0 100 30" className="w-full h-full overflow-visible" data-id="element-118">
                  <motion.path d={`M 0 ${20 + Math.random() * 10} Q 25 ${Math.random() * 20} 50 ${15 + Math.random() * 10} T 100 ${10 + Math.random() * 10}`} fill="none" stroke="currentColor" className={layer.accent} strokeWidth="2" initial={{
                pathLength: 0
              }} animate={{
                pathLength: 1
              }} transition={{
                duration: 1.5,
                delay: i * 0.2 + 0.5
              }} data-id="element-119" />
                </svg>
              </div>
            </GlassCard>
          </motion.div>)}
      </div>
    </div>;
}